import { TranslationsContext } from '@teliaee/telia-translate';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IFormHelperProps, TextField } from 'telia-front-react';
import { MAX_NAME_FIELD_LENGTH } from '../../../stores/CallbackStore';
import { useStores } from '../../../stores/RootStore';
import { helperInErrorState, NAME_FIELD_ID } from '../../../util/FieldHelperUtil';

const NameField = observer((): React.JSX.Element => {
  const {
    callbackStore: { callbackCreation, hasCallbackCreationFormSubmitted, getNameHelper }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);
  const [nameHelper, setNameHelper] = React.useState<IFormHelperProps | undefined>(undefined);

  React.useEffect(() => {
    setNameHelper(getNameHelper(translate));
  }, [callbackCreation.name, hasCallbackCreationFormSubmitted]);

  return (
    <TextField
      id={NAME_FIELD_ID}
      isInvalid={helperInErrorState(nameHelper)}
      value={callbackCreation.name}
      label={translate('reservation.requestCallback.name')}
      input={{ autoComplete: 'off', maxLength: MAX_NAME_FIELD_LENGTH }}
      onChange={(value: string) => runInAction(() => (callbackCreation.name = value))}
      errorMessage={helperInErrorState(nameHelper) ? (nameHelper.text as string) : undefined}
    />
  );
});

export default NameField;
